<script setup lang="ts">
import UAppBar from '@d/app/components/layout/UAppBar.vue'
import TreeView from '@d/app/components/tree/TreeView.vue'
import ULoading from '@d/app/components/util/ULoading.vue'
import { useDeviceBreakpoint } from '@d/app/composables/useDeviceBreakpoint'
import { provideStateScope } from '@d/app/helper/shortcut'
import UAlertBox from '@d/form/components/UAlertBox.vue'
import { Pane, Splitpanes } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import '../style/main.scss'

// const layoutData = defineLayoutController('default', { rightDrawer: false })

// interface DrawerTab {
//   title: string
//   icon: string
//   id: string
// }

// const drawerTabs = computed(() => ([
//   { title: t('')}
// ] as DrawerTab[]))

// const usermanager = inject(UserManagerSymbol)
const breakpoint = useDeviceBreakpoint()

const mobile = computed(() => breakpoint.smaller('tablet').value)

const disableAnimations = useLocalStorage('disableAnims', false)

const DRAWER_EXPANDED_DEFAULT = 20
const navSize = ref(mobile.value ? 0 : DRAWER_EXPANDED_DEFAULT)
const mainSize = computed(() => 100 - navSize.value)

function toggleDrawer(): void {
  if (navSize.value <= 1) {
    if (mobile.value) {
      navSize.value = 100
    }
    else {
      navSize.value = DRAWER_EXPANDED_DEFAULT
    }
  }
  else {
    navSize.value = 0
  }
}

watch(mobile, () => {
  if (mobile.value) {
    navSize.value = 0
  }
  // else {
  //   navSize.value = DRAWER_EXPANDED_DEFAULT
  // }
})

provideStateScope()
</script>

<template>
  <v-layout :class="{ 'is-mobile': mobile }">
    <!-- <v-system-bar color="deep-purple darken-3"></v-system-bar> -->

    <UAppBar show-toggle-drawer :left-drawer-size="navSize" @toggle-drawer="toggleDrawer()" />

    <Splitpanes class="up-theme" style="max-height: 100vh;" @resize="navSize = $event[0].size;">
      <Pane :size="navSize" style="padding-top: 64px; display: flex;flex-direction: column;" class="drawer-pane" min-size="5">
        <div class="d-flex" style="height: 100%">
          <!-- <v-card rounded="0" style="width: 48px">
            <v-btn icon rounded="0" size="48">
              <v-icon :icon="mdiDatabase" />
            </v-btn>
            <v-btn icon rounded="0" size="48">
              <v-icon :icon="mdiFolder" />
            </v-btn>
          </v-card>
          <v-divider vertical /> -->
          <div style="display: flex; width: 100%; flex-direction: column;" class="tree-view-wrapper">
            <TreeView :disable-animations="disableAnimations" />
          </div>
        </div>
        <!-- <v-navigation-drawer v-model="drawer"> -->

        <!-- </v-navigation-drawer> -->
      </Pane>
      <Pane :size="mainSize">
        <v-main style="display: flex;flex-direction: column; height: 100%; width: 100%;">
          <div style="display: flex; flex-direction: column; flex-grow: 1; overflow: auto; width: 100%;">
            <Suspense>
              <slot />
              <template #fallback>
                <ULoading class="loader" />
              </template>
            </Suspense>
          </div>
          <div>
            <UAlertBox />
          </div>
        </v-main>
      </Pane>
    </Splitpanes>
  </v-layout>
</template>

<style scoped>
.link{
  text-transform: none !important;
}

.loader {
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 0px;
  height: 100%;
}
</style>
